import type { ILink, IPagePath } from "@contentful-api/types/contentful";
import { resolveLinkExternalHref } from "@contentful-api/helpers/resolveLinkExternalHref";
import { isAllowedExternalUrl } from "@contentful-api/helpers/isAllowedExternalUrl";
import { Link, type LinkProps } from "@ecco/ui/link";
import { isEmpty } from "lodash-es";
import type { Ref } from "react";

type ExternalUrlProps = Omit<LinkProps, "ref"> & {
    link: ILink | IPagePath;
    ref?: Ref<HTMLAnchorElement>;
};

export const ExternalUrl = ({ link, children, ref, ...rest }: ExternalUrlProps) => {
    const fields = (link as ILink)?.fields;
    if (!fields) return null;

    const resolved = resolveLinkExternalHref(fields);
    const href = resolved?.href || "";
    const content = isEmpty(children) ? fields.label || "" : children;

    if (!href || !isAllowedExternalUrl(href)) return null;

    return (
        <Link
            href={href}
            target={
                href.startsWith("#")
                    ? undefined
                    : resolved?.isAsset || fields.internalLinkOnNewTab
                      ? "_blank"
                      : "_self"
            }
            rel="noopener noreferrer"
            ref={ref}
            {...rest}
        >
            {content}
        </Link>
    );
};

ExternalUrl.displayName = "ExternalUrl";
